export const ENABLE_ASSET_LEVEL_PREFERENCES = 'MO:Commenting:Notifications:EnableAssetLevelPreferences';
export const HUBSPOT_RTE_MIGRATION_ENABLED = 'MO:CollaborationSidebar:HubSpotRTEMigration';
export const DROP_AREA_LAYOUT_FIX = 'MO:DropAreaLayoutFix';